import { useState, useEffect } from "react";
import Switch from "@mui/material/Switch";
import FormControlLabel from "@mui/material/FormControlLabel";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import Icon from "@mui/material/Icon";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import TextField from "@mui/material/TextField";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import Menu from "@mui/material/Menu";
import Chip from "@mui/material/Chip";
import Divider from "@mui/material/Divider";
import IconButton from "@mui/material/IconButton";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import api from "api/axios";
import FormulaireInscriptionOumrah from "components/FormulaireInscriptionOumrah";
import Checkbox from "@mui/material/Checkbox";
import TimelineCycle from "components/TimelineCycle";
import DocumentsParticipant from "components/DocumentsParticipant";
import DesignationCouple from "components/DesignationCouple";
import BoutonSupprimer from "components/BoutonSupprimer";

const statutColor = {
  en_attente: "#888780",
  validee: "#378ADD",
  confirmee: "#1D9E75",
  annulee: "#e53935",
};
const statutLabel = {
  en_attente: "En attente",
  validee: "Validée",
  confirmee: "Confirmée",
  annulee: "Annulée",
};
// Ordre du cycle et action suivante par statut
const CYCLE = ["en_attente", "validee", "confirmee"];
const actionSuivante = {
  en_attente: { statut: "validee", label: "Valider", icon: "check" },
  validee: { statut: "confirmee", label: "Confirmer (payé)", icon: "verified" },
};

function OumrahInscriptions() {
  const [inscriptions, setInscriptions] = useState([]);
  const [sessions, setSessions] = useState([]);
  const [filtreSession, setFiltreSession] = useState("");
  const [filtreStatut, setFiltreStatut] = useState("");
  const [triDate, setTriDate] = useState("recent"); // "recent" | "ancien"
  const [filtreListeAttente, setFiltreListeAttente] = useState("toutes"); // "toutes" | "uniquement" | "exclure"
  const [menuActions, setMenuActions] = useState(null); // ancre du menu "Plus d'actions"

  const [detail, setDetail] = useState(null);
  const [openDetail, setOpenDetail] = useState(false);
  const [documentsData, setDocumentsData] = useState(null);
  const [paiement, setPaiement] = useState({ montant: "", mode: "", notes: "" });
  const [loadingPaiement, setLoadingPaiement] = useState(false);
  const [error, setError] = useState("");
  const [montrerArchivees, setMontrerArchivees] = useState(false);

  const fetchInscriptions = async () => {
    try {
      const url = "/oumrah/inscriptions" + (montrerArchivees ? "?archivees=true" : "");
      const res = await api.get(url);
      setInscriptions(res.data);
    } catch (err) {
      console.error(err);
    }
  };
  const fetchSessions = async () => {
    try {
      const res = await api.get("/oumrah/sessions");
      setSessions(res.data);
    } catch (err) {
      console.error(err);
    }
  };
  const handleSupprimer = async (id) => {
    if (!window.confirm("Supprimer définitivement cette inscription ? Cette action est irréversible et effacera aussi les participants, paiements et documents associés.")) return;
    try {
      await api.delete("/oumrah/inscriptions/" + id);
      fetchInscriptions();
    } catch (err) {
      alert(err.response?.data?.message || "Erreur lors de la suppression");
    }
  };

  useEffect(() => {
    fetchInscriptions();
    fetchSessions();
  }, [montrerArchivees]);

  const ouvrirDetail = async (id) => {
    setError("");
    setPaiement({ montant: "", mode: "", notes: "" });
    try {
      const res = await api.get(`/oumrah/inscriptions/${id}`);
      setDetail(res.data);
      chargerDocuments(id);
      setOpenDetail(true);
    } catch (err) {
      alert(err.response?.data?.message || "Erreur serveur");
    }
  };

  const chargerDocuments = async (inscriptionId) => {
    try {
      const res = await api.get("/oumrah/documents/inscription/" + inscriptionId);
      setDocumentsData(res.data);
    } catch (err) {
      setDocumentsData(null);
    }
  };

  const toggleDocument = async (participantId, typeId, fourni) => {
    try {
      await api.post("/oumrah/documents/cocher", {
        participant_id: participantId,
        type_document_id: typeId,
        fourni,
      });
      if (detail) chargerDocuments(detail.id);
    } catch (err) {
      alert(err.response?.data?.message || "Erreur");
    }
  };

  const majAssistance = async (p, champ, valeur) => {
    try {
      await api.put("/oumrah/inscriptions/participants/" + p.id + "/assistance", {
        besoin_assistance: champ === "besoin_assistance" ? valeur : p.besoin_assistance,
        fauteuil_roulant: champ === "fauteuil_roulant" ? valeur : p.fauteuil_roulant,
        malade: champ === "malade" ? valeur : p.malade,
        malade_details: champ === "malade_details" ? valeur : p.malade_details,
        besoin_carte_sejour: champ === "besoin_carte_sejour" ? valeur : p.besoin_carte_sejour,
      });
      if (detail) ouvrirDetail(detail.id);
    } catch (err) {
      alert(err.response?.data?.message || "Erreur");
    }
  };

  const majAccompagnateur = async (p, coche) => {
    if (coche) {
      const saisie = window.prompt("Montant du coût réel (hôtel + billet d'avion) pour cet accompagnateur :", "");
      if (saisie === null) return;
      const montant = parseFloat(saisie.replace(",", "."));
      if (isNaN(montant) || montant < 0) {
        alert("Montant invalide");
        return;
      }
      try {
        await api.put("/oumrah/inscriptions/participants/" + p.id + "/accompagnateur", { accompagnateur: true, montant });
        if (detail) ouvrirDetail(detail.id);
      } catch (err) {
        alert(err.response?.data?.message || "Erreur");
      }
    } else {
      if (!window.confirm("Décocher accompagnateur ? La dépense associée dans le bilan sera supprimée.")) return;
      try {
        await api.put("/oumrah/inscriptions/participants/" + p.id + "/accompagnateur", { accompagnateur: false });
        if (detail) ouvrirDetail(detail.id);
      } catch (err) {
        alert(err.response?.data?.message || "Erreur");
      }
    }
  };

  // === Remise ===
  const [remiseOpen, setRemiseOpen] = useState(false);
  const [remiseCible, setRemiseCible] = useState(null); // { type: "participant"|"inscription", id }
  const [remiseType, setRemiseType] = useState("montant");
  const [remiseValeur, setRemiseValeur] = useState("");

  const ouvrirRemiseParticipant = (p) => {
    if (p.accompagnateur) { alert("Un accompagnateur ne peut pas avoir de remise (deja a 0)"); return; }
    setRemiseCible({ type: "participant", id: p.id });
    setRemiseType(p.remise_type || "montant");
    setRemiseValeur(parseFloat(p.remise_valeur) > 0 ? String(p.remise_valeur) : "");
    setRemiseOpen(true);
  };
  const ouvrirRemiseInscription = () => {
    setRemiseCible({ type: "inscription", id: detail.id });
    setRemiseType(detail.remise_type || "montant");
    setRemiseValeur(parseFloat(detail.remise_valeur) > 0 ? String(detail.remise_valeur) : "");
    setRemiseOpen(true);
  };
  const enregistrerRemise = async (retirer) => {
    if (!remiseCible) return;
    const body = retirer
      ? { remise_valeur: 0 }
      : { remise_valeur: parseFloat((remiseValeur || "0").replace(",", ".")), remise_type: remiseType };
    if (!retirer && (isNaN(body.remise_valeur) || body.remise_valeur < 0)) {
      alert("Valeur invalide");
      return;
    }
    try {
      const url = remiseCible.type === "participant"
        ? "/oumrah/inscriptions/participants/" + remiseCible.id + "/remise"
        : "/oumrah/inscriptions/" + remiseCible.id + "/remise";
      await api.put(url, body);
      setRemiseOpen(false);
      if (detail) ouvrirDetail(detail.id);
    } catch (err) {
      alert(err.response?.data?.message || "Erreur");
    }
  };

  const [formOpen, setFormOpen] = useState(false);
  const ouvrirModification = () => setFormOpen(true);

  const docsDuParticipant = (participantId) => {
    if (!documentsData) return [];
    const p = documentsData.participants.find((x) => x.id === participantId);
    return p ? p.documents : [];
  };

  const enregistrerCouple = async (p1, p2) => {
    if (!detail) return;
    await api.put("/oumrah/inscriptions/" + detail.id + "/couple", {
      participant1_id: p1,
      participant2_id: p2,
    });
    await rafraichirDetail();
  };

  const rafraichirDetail = async () => {
    if (!detail) return;
    const res = await api.get(`/oumrah/inscriptions/${detail.id}`);
    setDetail(res.data);
    fetchInscriptions();
  };




  const changerStatut = async (statut, forcer) => {
    const message = forcer
      ? "Confirmer cette inscription SANS exiger le paiement complet ? Le reste à payer restera dû."
      : `Passer cette inscription en "${statutLabel[statut]}" ?`;
    if (!window.confirm(message)) return;
    try {
      await api.put(`/oumrah/inscriptions/${detail.id}/statut`, { statut, forcerSansPaiement: !!forcer });
      await rafraichirDetail();
    } catch (err) {
      alert(err.response?.data?.message || "Erreur serveur");
    }
  };
  const basculerListeAttente = async () => {
    const nouvel = !detail.liste_attente;
    const message = nouvel
      ? "Mettre cette inscription en liste d'attente ?"
      : "Retirer cette inscription de la liste d'attente ?";
    if (!window.confirm(message)) return;
    try {
      await api.put(`/oumrah/inscriptions/${detail.id}/liste-attente`, { liste_attente: nouvel });
      await rafraichirDetail();
    } catch (err) {
      alert(err.response?.data?.message || "Erreur serveur");
    }
  };

  const ajouterPaiement = async () => {
    setLoadingPaiement(true);
    setError("");
    try {
      await api.post("/oumrah/paiements", {
        inscription_id: detail.id,
        montant: parseFloat(paiement.montant),
        mode: paiement.mode || null,
        notes: paiement.notes || null,
      });
      setPaiement({ montant: "", mode: "", notes: "" });
      await rafraichirDetail();
    } catch (err) {
      setError(err.response?.data?.message || "Erreur serveur");
    } finally {
      setLoadingPaiement(false);
    }
  };

  const supprimerPaiement = async (id) => {
    if (!window.confirm("Supprimer ce règlement ?")) return;
    try {
      await api.delete(`/oumrah/paiements/${id}`);
      await rafraichirDetail();
    } catch (err) {
      alert(err.response?.data?.message || "Erreur serveur");
    }
  };

  // Calcule l'alerte passeport vs date de retour
  const alertePasseport = (dateExp, dateRetour) => {
    if (!dateExp || !dateRetour) return null;
    const exp = new Date(dateExp);
    const retour = new Date(dateRetour);
    if (exp < retour) {
      return { niveau: "error", texte: "Passeport expiré avant le retour" };
    }
    // 6 mois de validité après le retour (exigence fréquente pour les visas)
    const sixMois = new Date(retour);
    sixMois.setMonth(sixMois.getMonth() + 6);
    if (exp < sixMois) {
      return { niveau: "warning", texte: "Validité < 6 mois après le retour" };
    }
    return null;
  };

  const fmt = (n) => parseFloat(n || 0).toLocaleString("fr-FR");
  const fmtDate = (d) => {
    if (!d) return "";
    const dt = new Date(d);
    return dt.toLocaleDateString("fr-FR", { day: "2-digit", month: "2-digit", year: "numeric" });
  };
  const nomContact = (i) => {
    const p0 = i.participants && i.participants[0];
    if (!p0) return i.directeur_nom || "Sans nom";
    const base = `${p0.prenom || ""} ${p0.nom || ""}`.trim();
    const reste = parseInt(i.nb_participants || 0) - 1;
    return reste > 0 ? `${base} +${reste}` : base;
  };
  const villeDepart = (i) => {
    const p0 = i.participants && i.participants[0];
    return (p0 && p0.tarif_ville_depart) || null;
  };
  const couleurStatut = {
    en_attente: "#888780",
    validee: "#378ADD",
    confirmee: "#639922",
    annulee: "#E24B4A",
  };

  // Filtrage
  const inscriptionsFiltrees = inscriptions.filter((i) => {
    if (filtreSession && i.session_id !== parseInt(filtreSession)) return false;
    if (filtreStatut && i.statut !== filtreStatut) return false;
    if (filtreListeAttente === "uniquement" && !i.liste_attente) return false;
    if (filtreListeAttente === "exclure" && i.liste_attente) return false;
    return true;
  }).sort((a, b) => {
    const da = new Date(a.created_at).getTime();
    const db = new Date(b.created_at).getTime();
    return triDate === "recent" ? db - da : da - db;
  });

  // Regroupement par ville
  const parVille = {};
  inscriptionsFiltrees.forEach((i) => {
    const ville = i.directeur_ville || "Sans ville";
    if (!parVille[ville]) parVille[ville] = [];
    parVille[ville].push(i);
  });
  const villes = Object.keys(parVille).sort();
  const totalParticipantsGlobal = inscriptionsFiltrees.reduce(
    (sum, i) => sum + parseInt(i.nb_participants || 0), 0
  );

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox pt={6} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card>
              <MDBox
                mx={2} mt={-3} py={3} px={2}
                variant="gradient" bgColor="info"
                borderRadius="lg" coloredShadow="info"
              >
                <MDBox display="flex" justifyContent="space-between" alignItems="center">
                  <MDBox>
                    <MDTypography variant="h6" color="white">
                      Inscriptions Oumrah par ville
                    </MDTypography>
                    <MDBox display="flex" alignItems="baseline" gap={0.5} flexWrap="wrap">
                      <MDTypography variant="h4" color="white" fontWeight="bold">
                        {inscriptionsFiltrees.length}
                      </MDTypography>
                      <MDTypography variant="button" color="white" sx={{ opacity: 0.9 }}>
                        inscription{inscriptionsFiltrees.length > 1 ? "s" : ""} ·
                      </MDTypography>
                      <MDTypography variant="h4" color="white" fontWeight="bold" sx={{ ml: 0.5 }}>
                        {totalParticipantsGlobal}
                      </MDTypography>
                      <MDTypography variant="button" color="white" sx={{ opacity: 0.9 }}>
                        participant{totalParticipantsGlobal > 1 ? "s" : ""}
                      </MDTypography>
                    </MDBox>
                  </MDBox>
                  <FormControlLabel
                    control={<Switch checked={montrerArchivees} onChange={(e) => setMontrerArchivees(e.target.checked)} />}
                    label={<span style={{ color: "white", fontSize: "0.8rem" }}>Voir les archivées</span>}
                  />
                </MDBox>
              </MDBox>

              <MDBox pt={3} px={3} pb={3}>
                {/* Filtres */}
                <MDBox display="flex" gap={2} mb={3} flexWrap="wrap">
                  <FormControl size="small" sx={{ minWidth: 220 }}>
                    <InputLabel id="fs-label">Session</InputLabel>
                    <Select
                      labelId="fs-label"
                      label="Session"
                      sx={{ height: 44 }}
                      value={filtreSession}
                      onChange={(e) => setFiltreSession(e.target.value)}
                    >
                      <MenuItem value="">Toutes</MenuItem>
                      {sessions.map((s) => (
                        <MenuItem key={s.id} value={s.id}>{s.libelle}</MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                  <FormControl size="small" sx={{ minWidth: 180 }}>
                    <InputLabel id="fst-label">Statut</InputLabel>
                    <Select
                      labelId="fst-label"
                      label="Statut"
                      sx={{ height: 44 }}
                      value={filtreStatut}
                      onChange={(e) => setFiltreStatut(e.target.value)}
                    >
                      <MenuItem value="">Tous</MenuItem>
                      <MenuItem value="en_attente">En attente</MenuItem>
                      <MenuItem value="validee">Validée</MenuItem>
                      <MenuItem value="confirmee">Confirmée</MenuItem>
                      <MenuItem value="annulee">Annulée</MenuItem>
                    </Select>
                  </FormControl>
                  <FormControl size="small" sx={{ minWidth: 200 }}>
                    <InputLabel id="tri-label">Trier par date</InputLabel>
                    <Select labelId="tri-label" label="Trier par date" sx={{ height: 44 }} value={triDate} onChange={(e) => setTriDate(e.target.value)}>
                      <MenuItem value="recent">Plus recentes d'abord</MenuItem>
                      <MenuItem value="ancien">Plus anciennes d'abord</MenuItem>
                    </Select>
                  </FormControl>
                  <FormControl size="small" sx={{ minWidth: 190 }}>
                    <InputLabel id="la-label">Liste d'attente</InputLabel>
                    <Select labelId="la-label" label="Liste d'attente" sx={{ height: 44 }} value={filtreListeAttente} onChange={(e) => setFiltreListeAttente(e.target.value)}>
                      <MenuItem value="toutes">Toutes</MenuItem>
                      <MenuItem value="uniquement">Uniquement liste d'attente</MenuItem>
                      <MenuItem value="exclure">Exclure liste d'attente</MenuItem>
                    </Select>
                  </FormControl>
                </MDBox>

                {/* Accordéons par ville */}
                {villes.map((ville) => {
                  const liste = parVille[ville];
                  const nbParticipants = liste.reduce(
                    (sum, i) => sum + parseInt(i.nb_participants || 0), 0
                  );
                  return (
                    <Accordion key={ville} defaultExpanded sx={{ mb: 2, borderRadius: 2, "&:before": { display: "none" } }}>
                      <AccordionSummary
                        expandIcon={<Icon>expand_more</Icon>}
                        sx={{ bgcolor: "#f5f7fa", borderRadius: 2 }}
                      >
                        <MDBox display="flex" alignItems="center" gap={1} width="100%">
                          <Icon color="info">location_city</Icon>
                          <MDTypography variant="h6">{ville}</MDTypography>
                          <MDTypography variant="caption" color="text" sx={{ ml: 1 }}>
                            {liste.length} inscription(s) · {nbParticipants} participant(s)
                          </MDTypography>
                        </MDBox>
                      </AccordionSummary>
                      <AccordionDetails>
                        {liste.map((i) => (
                          <Accordion key={i.id} sx={{ mb: 1, boxShadow: "none", border: "1px solid #eee", "&:before": { display: "none" } }}>
                            <AccordionSummary expandIcon={<Icon>expand_more</Icon>}>
                              <MDBox display="flex" justifyContent="space-between" alignItems="center" width="100%" flexWrap="wrap" gap={1.5}>
                                <MDBox sx={{ minWidth: 0, flex: 1 }}>
                                  <MDTypography variant="button" fontWeight="bold" display="block">
                                    {nomContact(i)}
                                  </MDTypography>
                                  <MDTypography variant="caption" color="text" display="block">
                                    <span style={{ textTransform: "capitalize", color: "#378ADD", fontWeight: 600 }}>{i.type_inscription}</span>
                                    {" · "}Formule {i.session_libelle}
                                  </MDTypography>
                                  {villeDepart(i) && (
                                    <MDBox display="flex" alignItems="center" gap={0.5} mt={0.25} sx={{ color: "#6a1b9a" }}>
                                      <Icon sx={{ fontSize: "0.9rem !important" }}>flight_takeoff</Icon>
                                      <MDTypography variant="caption" sx={{ color: "#6a1b9a", fontWeight: 600 }}>
                                        {villeDepart(i)}
                                      </MDTypography>
                                    </MDBox>
                                  )}
                                </MDBox>
                                <MDBox display="flex" alignItems="center" justifyContent="flex-end" gap={0.5} sx={{ color: "#495057", whiteSpace: "nowrap", minWidth: 130 }}>
                                  <Icon sx={{ fontSize: "0.95rem !important", color: "#868e96" }}>event</Icon>
                                  <MDTypography variant="caption" sx={{ color: "#495057", fontWeight: 600 }}>{fmtDate(i.created_at)}</MDTypography>
                                </MDBox>
                                <Chip
                                  label={statutLabel[i.statut]}
                                  size="small"
                                  icon={<span style={{ width: 8, height: 8, borderRadius: "50%", background: couleurStatut[i.statut] || "#888", marginLeft: 8 }} />}
                                  sx={{
                                    bgcolor: "transparent",
                                    color: couleurStatut[i.statut] || "#555",
                                    fontWeight: "bold",
                                    border: "1px solid #e0e0e0",
                                    width: 120,
                                    justifyContent: "flex-start",
                                    "& .MuiChip-icon": { order: -1 },
                                    "& .MuiChip-label": { flex: 1 },
                                  }}
                                />
                                {i.liste_attente && (
                                  <Chip
                                    label="Liste d'attente"
                                    size="small"
                                    icon={<Icon sx={{ fontSize: "0.9rem !important", color: "#BA7517 !important" }}>hourglass_top</Icon>}
                                    sx={{
                                      bgcolor: "#FAEEDA",
                                      color: "#854F0B",
                                      fontWeight: "bold",
                                      border: "1px solid #EF9F27",
                                      "& .MuiChip-icon": { order: -1 },
                                    }}
                                  />
                                )}
                              </MDBox>
                            </AccordionSummary>
                            <AccordionDetails sx={{ bgcolor: "#fafafa" }}>
                              {/* Participants */}
                              {i.participants.map((p) => {
                                const chambreLabel = {
                                  double: "Chambre double",
                                  triple: "Chambre triple",
                                  quadruple: "Chambre quadruple",
                                }[p.tarif_type_chambre] || p.tarif_libelle || "Sans tarif";
                                const montantAvecSupplement = (p.tarif_montant ? parseFloat(p.tarif_montant) : 0) + (p.besoin_carte_sejour ? parseFloat(i.supplement_carte_sejour || 0) : 0);
                                return (
                                  <MDBox key={p.id} py={0.75} sx={{ borderBottom: "1px dashed #eee", "&:last-child": { borderBottom: "none" } }}>
                                    <MDBox display="flex" justifyContent="space-between" alignItems="baseline">
                                      <MDTypography variant="caption" fontWeight="bold">
                                        <Icon sx={{ verticalAlign: "middle", fontSize: "1rem !important" }}>person</Icon>
                                        &nbsp;{p.prenom} {p.nom} {p.sexe ? `(${p.sexe})` : ""}
                                      </MDTypography>
                                      <MDTypography variant="caption" fontWeight="bold" color="info">
                                        {fmt(montantAvecSupplement)} €
                                      </MDTypography>
                                    </MDBox>
                                    <MDBox display="flex" gap={0.75} alignItems="center" flexWrap="wrap" mt={0.5}>
                                      {p.tarif_ville_depart && (
                                        <Chip
                                          size="small"
                                          icon={<Icon fontSize="small">flight_takeoff</Icon>}
                                          label={p.tarif_ville_depart}
                                          sx={{ bgcolor: "#e3f2fd", color: "#1565c0", fontWeight: "bold", height: 22, "& .MuiChip-icon": { color: "#1565c0" } }}
                                        />
                                      )}
                                      {p.tarif_type_chambre && (
                                        <Chip
                                          size="small"
                                          icon={<Icon fontSize="small">bed</Icon>}
                                          label={chambreLabel}
                                          sx={{ bgcolor: "#f3e5f5", color: "#6a1b9a", fontWeight: "bold", height: 22, "& .MuiChip-icon": { color: "#6a1b9a" } }}
                                        />
                                      )}
                                      {p.besoin_carte_sejour && (
                                        <Chip
                                          size="small"
                                          icon={<Icon fontSize="small">badge</Icon>}
                                          label={"Carte de séjour +" + fmt(i.supplement_carte_sejour || 0) + " €"}
                                          sx={{ bgcolor: "#fff3e0", color: "#e65100", fontWeight: "bold", height: 22, "& .MuiChip-icon": { color: "#e65100" } }}
                                        />
                                      )}
                                    </MDBox>
                                  </MDBox>
                                );
                              })}
                              {i.participants.length === 0 && (
                                <MDTypography variant="caption" color="text">Aucun participant</MDTypography>
                              )}
                              {i.statut !== "annulee" && typeof i.montant_du === "number" && (
                                <MDBox mt={1.5} sx={{ bgcolor: "#f8f9fa", borderRadius: "8px", p: 1.5 }}>
                                  <MDBox display="flex" justifyContent="space-between" alignItems="baseline" mb={0.5}>
                                    <MDTypography variant="caption" color="text">
                                      Payé : <b>{fmt(i.montant_paye)} €</b>
                                    </MDTypography>
                                    <MDTypography variant="button" sx={{ color: (i.reste_a_payer <= 0 ? "#1D9E75" : "#e67e22"), fontWeight: "bold" }}>
                                      Reste : {fmt(i.reste_a_payer)} €
                                    </MDTypography>
                                  </MDBox>
                                  <MDBox sx={{ height: 6, borderRadius: 3, bgcolor: "#e0e0e0", overflow: "hidden" }}>
                                    <MDBox
                                      sx={{
                                        height: "100%",
                                        width: (i.montant_du > 0 ? Math.min(100, (i.montant_paye / i.montant_du) * 100) : 0) + "%",
                                        bgcolor: i.reste_a_payer <= 0 ? "#1D9E75" : "#2196f3",
                                        transition: "width 0.3s",
                                      }}
                                    />
                                  </MDBox>
                                </MDBox>
                              )}
                              <MDBox mt={1.5} display="flex" gap={1}>
                                <MDButton size="small" color="info" variant="gradient" onClick={() => ouvrirDetail(i.id)}>
                                  <Icon>visibility</Icon>&nbsp;Détail / Valider / Paiements
                                </MDButton>
                                <MDButton size="small" color="error" variant="outlined" onClick={() => handleSupprimer(i.id)}>
                                  <Icon>close</Icon>&nbsp;Supprimer
                                </MDButton>
                              </MDBox>
                            </AccordionDetails>
                          </Accordion>
                        ))}
                      </AccordionDetails>
                    </Accordion>
                  );
                })}

                {villes.length === 0 && (
                  <MDTypography variant="body2" color="text" textAlign="center">
                    Aucune inscription.
                  </MDTypography>
                )}
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>

      {/* DIALOG DÉTAIL (validation + paiements) */}
      <Dialog open={openDetail} onClose={() => setOpenDetail(false)} fullWidth maxWidth="md">
        {detail && (
          <>
            <DialogTitle>
              <MDBox display="flex" justifyContent="space-between" alignItems="center">
                <span>{detail.session_libelle}</span>
                <Chip
                  label={statutLabel[detail.statut]}
                  size="small"
                  sx={{ bgcolor: statutColor[detail.statut], color: "white" }}
                />
              </MDBox>
            </DialogTitle>
            <DialogContent dividers>
              <TimelineCycle statut={detail.statut} />
              <MDTypography variant="caption" color="text" display="block" mb={1}>
                Directeur : {detail.directeur_nom} · Type : {detail.type_inscription}
              </MDTypography>
              {detail.notes && (
                <MDTypography variant="caption" color="text" display="block" mb={1}>
                  Notes : {detail.notes}
                </MDTypography>
              )}

              <MDTypography variant="button" fontWeight="bold" mt={2} display="block">
                Participants
              </MDTypography>
              {detail.participants.map((p) => {
                const alerte = alertePasseport(p.date_expiration_passeport, detail.session_date_retour);
                const val = (v) => v ? v : null;
                return (
                  <Card key={p.id} sx={{ p: 2.5, mb: 2, border: "1px solid #d0d7de", borderRadius: 2 }}>
                    <MDBox display="flex" justifyContent="space-between" alignItems="flex-start" mb={1.5} flexWrap="wrap" gap={1}>
                      <MDBox display="flex" alignItems="center" gap={1}>
                        <Icon color="info">account_circle</Icon>
                        <MDTypography variant="h6">
                          {p.prenom} {p.nom ? p.nom.toUpperCase() : ""}
                        </MDTypography>
                      </MDBox>
                      <Chip label={(p.tarif_ville_depart ? p.tarif_ville_depart + " - " : "") + (p.tarif_libelle || "Sans tarif") + " · " + fmt(p.tarif_montant) + " €"}
                        size="small" sx={{ bgcolor: "#1A73E8", color: "white", fontWeight: "bold" }} />
                    </MDBox>

                    <MDTypography variant="button" color="text" display="block" mb={1.5}>
                      {p.sexe === "H" ? "Homme" : p.sexe === "F" ? "Femme" : "Sexe non renseigné"}{p.nationalite ? " · " + p.nationalite : ""}
                      {val(p.date_naissance)
                        ? " · né(e) le " + new Date(p.date_naissance).toLocaleDateString("fr-FR")
                        : ""}
                    </MDTypography>

                    {/* Bloc passeport mis en avant */}
                    <MDBox p={1.5} mb={1.5} borderRadius="md" sx={{ bgcolor: "#f5f7fa", border: "1px solid #e0e0e0" }}>
                      <MDBox display="flex" alignItems="center" gap={1} flexWrap="wrap">
                        <Icon fontSize="small" color="info">badge</Icon>
                        <MDTypography variant="button" color="text">Passeport&nbsp;:</MDTypography>
                        <MDTypography variant="button" fontWeight="bold" color="dark">
                          {p.num_passeport || "non renseigné"}
                        </MDTypography>
                        {val(p.date_expiration_passeport) && (
                          <>
                            <MDTypography variant="button" color="text">&nbsp;·&nbsp;expire le</MDTypography>
                            <MDTypography variant="button" fontWeight="bold" color="dark">
                              {new Date(p.date_expiration_passeport).toLocaleDateString("fr-FR")}
                            </MDTypography>
                          </>
                        )}
                      </MDBox>
                      {alerte && (
                        <MDBox mt={1} display="flex" alignItems="center" gap={0.5}>
                          <Icon fontSize="small" color={alerte.niveau === "error" ? "error" : "warning"}>warning</Icon>
                          <MDTypography variant="button" fontWeight="bold"
                            color={alerte.niveau === "error" ? "error" : "warning"}>
                            {alerte.texte}
                          </MDTypography>
                        </MDBox>
                      )}
                    </MDBox>

                    {/* Contact */}
                    <MDBox display="flex" gap={3} flexWrap="wrap">
                      <MDBox display="flex" alignItems="center" gap={0.5}>
                        <Icon fontSize="small" color="text">phone</Icon>
                        <MDTypography variant="button" fontWeight={p.telephone ? "bold" : "regular"} color={p.telephone ? "dark" : "text"}>
                          {p.telephone || "non renseigné"}
                        </MDTypography>
                      </MDBox>
                      <MDBox display="flex" alignItems="center" gap={0.5}>
                        <Icon fontSize="small" color="text">email</Icon>
                        <MDTypography variant="button" fontWeight={p.email ? "bold" : "regular"} color={p.email ? "dark" : "text"}>
                          {p.email || "non renseigné"}
                        </MDTypography>
                      </MDBox>
                    </MDBox>
                    <MDBox mt={1.5} pt={1.5} sx={{ borderTop: "1px solid #f0f0f0" }}>
                      <MDBox display="flex" alignItems="center">
                        <Checkbox checked={!!p.accompagnateur} onChange={(e) => majAccompagnateur(p, e.target.checked)} size="small" />
                        <MDTypography variant="caption" fontWeight={p.accompagnateur ? "bold" : "regular"} color={p.accompagnateur ? "success" : "text"}>
                          Accompagnateur (ne paye pas, coût réel comptabilisé dans le bilan)
                        </MDTypography>
                      </MDBox>
                    </MDBox>
                    <MDBox mt={1} display="flex" alignItems="center" gap={1} flexWrap="wrap">
                      <MDButton size="small" variant="outlined" color="warning" onClick={() => ouvrirRemiseParticipant(p)}>
                        <Icon fontSize="small">percent</Icon>&nbsp;Remise
                      </MDButton>
                      {parseFloat(p.remise_valeur) > 0 && (
                        <MDTypography variant="caption" color="success" fontWeight="bold">
                          -{p.remise_valeur}{p.remise_type === "pourcent" ? "%" : " €"} appliquée
                        </MDTypography>
                      )}
                    </MDBox>
                    <MDBox mt={1.5} pt={1.5} sx={{ borderTop: "1px solid #f0f0f0" }}>
                      <MDTypography variant="caption" color="text" fontWeight="bold" display="block" mb={0.5}>
                        Assistance :
                      </MDTypography>
                      <MDBox display="flex" flexWrap="wrap" gap={1} alignItems="center" mb={1}>
                        <MDBox display="flex" alignItems="center">
                          <Checkbox checked={!!p.besoin_assistance} onChange={(e) => majAssistance(p, "besoin_assistance", e.target.checked)} size="small" />
                          <MDTypography variant="caption">Besoin d'assistance</MDTypography>
                        </MDBox>
                        <MDBox display="flex" alignItems="center">
                          <Checkbox checked={!!p.fauteuil_roulant} onChange={(e) => majAssistance(p, "fauteuil_roulant", e.target.checked)} size="small" />
                          <MDTypography variant="caption">Fauteuil roulant</MDTypography>
                        </MDBox>
                        <MDBox display="flex" alignItems="center">
                          <Checkbox checked={!!p.malade} onChange={(e) => majAssistance(p, "malade", e.target.checked)} size="small" />
                          <MDTypography variant="caption">Malade</MDTypography>
                        </MDBox>
                        <MDBox display="flex" alignItems="center">
                          <Checkbox checked={!!p.besoin_carte_sejour} onChange={(e) => majAssistance(p, "besoin_carte_sejour", e.target.checked)} size="small" />
                          <MDTypography variant="caption">Le participant possède une carte de séjour</MDTypography>
                        </MDBox>
                      </MDBox>
                      {p.malade && (
                        <MDBox mb={1.5}>
                          <TextField label="Précisions sur la maladie" fullWidth size="small" multiline rows={2}
                            defaultValue={p.malade_details || ""}
                            onBlur={(e) => { if ((e.target.value || "") !== (p.malade_details || "")) majAssistance(p, "malade_details", e.target.value); }} />
                        </MDBox>
                      )}
                    </MDBox>
                    <MDBox mt={1.5} pt={1.5} sx={{ borderTop: "1px solid #f0f0f0" }}>
                      <MDTypography variant="caption" color="text" fontWeight="bold" display="block" mb={0.5}>
                        Documents :
                      </MDTypography>
                      <DocumentsParticipant
                        documents={docsDuParticipant(p.id)}
                        onToggle={(typeId, fourni) => toggleDocument(p.id, typeId, fourni)}
                        participantId={p.id}
                      />
                    </MDBox>
                  </Card>
                );
              })}

              <DesignationCouple inscription={detail} onSave={enregistrerCouple} />

              <MDBox mt={3} sx={{ bgcolor: "#f8f9fa", borderRadius: "8px", p: 2 }}>
                <MDTypography variant="overline" color="text" fontWeight="bold" sx={{ letterSpacing: 0.5 }}>
                  Paiement
                </MDTypography>
                <MDBox display="flex" justifyContent="space-between" alignItems="center" mt={0.5}>
                  <MDBox display="flex" alignItems="center" gap={1}>
                    <MDTypography variant="button">Montant dû</MDTypography>
                    <MDButton size="small" variant="outlined" color="warning" onClick={ouvrirRemiseInscription}>
                      <Icon fontSize="small">percent</Icon>&nbsp;Remise
                    </MDButton>
                    {parseFloat(detail.remise_valeur) > 0 && (
                      <MDTypography variant="caption" color="success" fontWeight="bold">
                        -{detail.remise_valeur}{detail.remise_type === "pourcent" ? "%" : " €"}
                      </MDTypography>
                    )}
                  </MDBox>
                  <MDTypography variant="button" fontWeight="bold">{fmt(detail.montant_du)} €</MDTypography>
                </MDBox>
                <MDBox display="flex" justifyContent="space-between" mt={0.5}>
                  <MDTypography variant="button">Payé</MDTypography>
                  <MDTypography variant="button" fontWeight="bold" color="success">{fmt(detail.montant_paye)} €</MDTypography>
                </MDBox>
                <MDBox display="flex" justifyContent="space-between" mt={0.5} mb={1}>
                  <MDTypography variant="button">Reste à payer</MDTypography>
                  <MDTypography variant="button" fontWeight="bold" color="error">{fmt(detail.reste_a_payer)} €</MDTypography>
                </MDBox>
                <MDBox sx={{ height: 6, borderRadius: 3, bgcolor: "#e0e0e0", overflow: "hidden" }}>
                  <MDBox
                    sx={{
                      height: "100%",
                      width: (detail.montant_du > 0 ? Math.min(100, (detail.montant_paye / detail.montant_du) * 100) : 0) + "%",
                      bgcolor: detail.reste_a_payer <= 0 ? "#1D9E75" : "#2196f3",
                      transition: "width 0.3s",
                    }}
                  />
                </MDBox>
              </MDBox>

              <MDBox mt={3}>
                <MDTypography variant="overline" color="text" fontWeight="bold" sx={{ letterSpacing: 0.5 }} display="block" mb={1}>
                  Règlements
                </MDTypography>
                {detail.paiements.length === 0 && (
                  <MDTypography variant="caption" color="text" display="block" mb={1}>
                    Aucun règlement enregistré.
                  </MDTypography>
                )}
                {detail.paiements.map((pmt) => (
                  <MDBox key={pmt.id} display="flex" justifyContent="space-between" alignItems="center" py={0.75}
                    sx={{ borderBottom: "1px dashed #eee" }}>
                    <MDTypography variant="caption" color="text">
                      {new Date(pmt.date_paiement).toLocaleDateString("fr-FR")} · <b>{fmt(pmt.montant)} €</b>
                      {pmt.mode ? ` · ${pmt.mode}` : ""}
                      {pmt.notes ? ` · ${pmt.notes}` : ""}
                    </MDTypography>
                    <IconButton size="small" onClick={() => supprimerPaiement(pmt.id)}>
                      <Icon fontSize="small">delete</Icon>
                    </IconButton>
                  </MDBox>
                ))}

                <MDBox display="flex" gap={1} alignItems="center" mt={2} flexWrap="wrap">
                <TextField
                  label="Montant €" type="number" size="small"
                  value={paiement.montant}
                  onChange={(e) => setPaiement({ ...paiement, montant: e.target.value })}
                />
                <FormControl size="small" sx={{ minWidth: 130 }}>
                  <InputLabel id="mode-paiement-label">Mode</InputLabel>
                  <Select
                    labelId="mode-paiement-label"
                    label="Mode"
                    value={paiement.mode}
                    onChange={(e) => setPaiement({ ...paiement, mode: e.target.value })}
                    sx={{ height: 40 }}
                  >
                    <MenuItem value="espece">Espèce</MenuItem>
                    <MenuItem value="virement">Virement</MenuItem>
                    <MenuItem value="cheque">Chèque</MenuItem>
                  </Select>
                </FormControl>
                <TextField
                  label="Notes" size="small"
                  value={paiement.notes}
                  onChange={(e) => setPaiement({ ...paiement, notes: e.target.value })}
                />
                <MDButton size="small" color="info" onClick={ajouterPaiement} disabled={loadingPaiement || !paiement.montant}>
                  <Icon>add</Icon>&nbsp;Ajouter
                </MDButton>
              </MDBox>
              </MDBox>
              {error && (
                <MDTypography variant="caption" color="error" display="block" mt={1}>
                  {error}
                </MDTypography>
              )}
            </DialogContent>
            <DialogActions sx={{ gap: 1, flexWrap: "wrap" }}>
              {actionSuivante[detail.statut] && (
                <MDButton color="info" onClick={() => changerStatut(actionSuivante[detail.statut].statut)}>
                  <Icon>{actionSuivante[detail.statut].icon}</Icon>&nbsp;{actionSuivante[detail.statut].label}
                </MDButton>
              )}
              {actionSuivante[detail.statut] && (
                <MDButton
                  color="success"
                  variant="outlined"
                  onClick={() => changerStatut(actionSuivante[detail.statut].statut, true)}
                >
                  <Icon>bolt</Icon>&nbsp;Valider sans paiement
                </MDButton>
              )}
              <MDBox sx={{ flex: 1 }} />
              <MDButton
                color="secondary"
                variant="outlined"
                onClick={(e) => setMenuActions(e.currentTarget)}
              >
                <Icon>more_horiz</Icon>&nbsp;Plus d'actions
              </MDButton>
              <Menu
                anchorEl={menuActions}
                open={Boolean(menuActions)}
                onClose={() => setMenuActions(null)}
                anchorOrigin={{ vertical: "top", horizontal: "right" }}
                transformOrigin={{ vertical: "bottom", horizontal: "right" }}
              >
                <MenuItem onClick={() => { setMenuActions(null); ouvrirModification(); }}>
                  <Icon sx={{ mr: 1 }}>edit</Icon>Modifier
                </MenuItem>
                <MenuItem onClick={() => { setMenuActions(null); basculerListeAttente(); }} sx={{ color: "#854F0B" }}>
                  <Icon sx={{ mr: 1, color: "#854F0B" }}>{detail.liste_attente ? "hourglass_disabled" : "hourglass_top"}</Icon>
                  {detail.liste_attente ? "Retirer de la liste d'attente" : "Mettre en liste d'attente"}
                </MenuItem>
                {CYCLE.indexOf(detail.statut) > 0 && detail.statut !== "annulee" && (
                  <MenuItem onClick={() => { setMenuActions(null); changerStatut(CYCLE[CYCLE.indexOf(detail.statut) - 1]); }}>
                    <Icon sx={{ mr: 1 }}>arrow_back</Icon>Reculer le statut
                  </MenuItem>
                )}
                <MenuItem divider disabled sx={{ opacity: "0.6 !important", fontSize: 12 }}>
                  Forcer un statut
                </MenuItem>
                {Object.keys(statutLabel).map((st) => (
                  <MenuItem
                    key={st}
                    disabled={st === detail.statut}
                    onClick={() => { setMenuActions(null); changerStatut(st); }}
                    sx={{ pl: 3 }}
                  >
                    {statutLabel[st]}
                  </MenuItem>
                ))}
                {detail.statut !== "annulee" && (
                  <MenuItem onClick={() => { setMenuActions(null); changerStatut("annulee"); }} divider sx={{ color: "#A32D2D", borderTop: "1px solid #eee" }}>
                    <Icon sx={{ mr: 1, color: "#A32D2D" }}>cancel</Icon>Annuler l'inscription
                  </MenuItem>
                )}
              </Menu>
              <MDButton color="secondary" onClick={() => setOpenDetail(false)}>Fermer</MDButton>
            </DialogActions>
          </>
        )}
      </Dialog>


      <Dialog open={remiseOpen} onClose={() => setRemiseOpen(false)} maxWidth="xs" fullWidth>
        <DialogTitle>
          {remiseCible?.type === "participant" ? "Remise sur ce participant" : "Remise sur l'inscription"}
        </DialogTitle>
        <DialogContent dividers>
          <MDBox display="flex" gap={2} alignItems="center" mb={2} mt={1}>
            <Select value={remiseType} onChange={(e) => setRemiseType(e.target.value)} size="small" sx={{ minWidth: 140 }}>
              <MenuItem value="montant">Montant (€)</MenuItem>
              <MenuItem value="pourcent">Pourcentage (%)</MenuItem>
            </Select>
            <TextField label="Valeur" type="number" size="small" fullWidth
              value={remiseValeur} onChange={(e) => setRemiseValeur(e.target.value)}
              inputProps={{ min: 0, step: "0.01" }} />
          </MDBox>
          <MDTypography variant="caption" color="text">
            {remiseType === "pourcent" ? "Ex : 10 = -10% sur le tarif" : "Ex : 50 = -50 € sur le tarif"}
          </MDTypography>
        </DialogContent>
        <DialogActions>
          <MDButton color="error" variant="outlined" onClick={() => enregistrerRemise(true)}>
            Retirer la remise
          </MDButton>
          <MDButton onClick={() => setRemiseOpen(false)}>Annuler</MDButton>
          <MDButton color="info" onClick={() => enregistrerRemise(false)}>Enregistrer</MDButton>
        </DialogActions>
      </Dialog>
      <FormulaireInscriptionOumrah
        open={formOpen}
        onClose={() => setFormOpen(false)}
        editId={detail ? detail.id : null}
        onSaved={() => { if (detail) ouvrirDetail(detail.id); fetchInscriptions(); }}
      />
      <Footer />
    </DashboardLayout>
  );
}

export default OumrahInscriptions;
